import { render } from "./CourseGeneral.vue?vue&type=template&id=16f3f004"
import script from "./CourseGeneral.vue?vue&type=script&lang=js"
export * from "./CourseGeneral.vue?vue&type=script&lang=js"

import "./CourseGeneral.vue?vue&type=style&index=0&id=16f3f004&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__